export default function () {
    return async ({next}) => {
        try {
            await window.playNotificationSound();
        } catch (e) {
            //ignore
        }
        next();
    }
}
